export default __webpack_public_path__ + "static/media/249.005305e5.jpg";